export function Semantic({ size = 48 }) {
    return (
      <svg
        viewBox="0 0 84 60"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={(size * 60) / 84} 
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M83.2 18.2998C80.3 20.0998 78.2001 21.1998 75.8001 22.5998C61.4001 31.2998 47.5 40.9998 36.8 53.6998L31.6 59.9998L15.8 34.7998C19.3 37.5998 28.2 45.4998 31.8 47.2998L43.4001 38.4998C51.5001 32.7998 74.4 20.3998 83.2 18.2998Z"
          fill="#F3D25E"
        />
        <path
          d="M23.2 37.0996C23.6 37.3996 23.9 37.6996 24.3 37.9996C21.2 29.2996 15.7 20.5996 7.9 13.0996C5.3 13.0996 2.7 13.0996 0 13.0996C10 20.2996 17.8 28.6996 23.2 37.0996Z"
          fill="#638BC4"
        />
        <path
          d="M25.8 39.4004C26.1 39.7004 26.5 39.9004 26.8 40.2004C26.3 28.4004 21.9 16.3004 13.5 5.90039C11 5.90039 8.5 5.90039 6 5.90039C16.7 15.8004 23.3 27.8004 25.8 39.4004Z"
          fill="#305CA5"
        />
        <path
          d="M27.9 41.1C29.1 42.1 30.2999 43 31.2999 43.7C33.8999 31 31.7 17.3 24.8 5.4C36.5 5.2 48.1999 5.1 59.7999 4.9C62.3999 10.7 63.9 16.9 64.3 23.3C65.3 22.8 66.3 22.3 67.4 21.8C66.9 15.2 65.0999 8.2 61.5999 0C45.5999 0 29.7 0 13.7 0C24.1 12.3 28.8 27.2 27.9 41.1Z"
          fill="#273D72"
        />
      </svg>
    );
  }
  